<!-- eslint-disable vue/require-explicit-emits -->
<template>
  <iColumn
    :class="{
      ...classList,
      'empty-layout': isEmpty && !hasABorder,
      'root-layout': isRootLayout,
      'layout': true,
    }"
    v-bind="{
      ...myLayoutProps,
      'data-identifier': identifier,
      'data-parent-id': identifier,
      'draggable': editMode && isDraggable(identifier, configuration) && !breakpoint
    }"
    v-on="myEventListeners"
  >
    <Teleport to="body">
      <DynamicComponentContextualMenu
        v-if="(isDynamicAppComponent ? true : canEditPublication)
          && showContextualMenu
          && contextMenuFixedPositionStyle.top
          && contextMenuFixedPositionStyle.left"
        ref="contextualMenu"
        v-bind="contextMenuAttrs"
        v-on="contextMenuEvents"
      />
    </Teleport>
    <div
      v-if="canResizeHorizontally && (mouseOver || selectedHoverBorder)"
      class="resize-handle left"
      @mousedown.stop="handleMouseDownResize($event, 'left')"
    />
    <div
      v-if="canResizeHorizontally && (mouseOver || selectedHoverBorder)"
      class="resize-handle right"
      @mousedown.stop="handleMouseDownResize($event, 'right')"
    />
    <div
      v-if="canResizeVertically && (mouseOver || selectedHoverBorder)"
      class="resize-handle top"
      @mousedown.stop="handleMouseDownResize($event, 'top')"
    />
    <div
      v-if="canResizeVertically && (mouseOver || selectedHoverBorder)"
      class="resize-handle bottom"
      @mousedown.stop="handleMouseDownResize($event, 'bottom')"
    />
    <slot />
  </iColumn>
</template>

<script>
import {
  LayoutElementMixin,
} from "%/dynamic-component-editor/standard-elements/layouts/layout-element-mixin";
import SpacingOptions from "%/dynamic-component-editor/bundles/spacing-options";
import BackgroundOptions from "%/dynamic-component-editor/bundles/background-options";
import LayoutWrap from "%/dynamic-component-editor/options/layout-wrap";
import VerticalLayoutAlign from "%/dynamic-component-editor/options/vertical-layout-align";
import VerticalLayoutVerticalAlign
  from "%/dynamic-component-editor/options/vertical-layout-vertical-align";
import VerticalLayoutPositionOptions from "%/dynamic-component-editor/bundles/vertical-layout-position-options";
import RootLayoutPositionOptions from "%/dynamic-component-editor/bundles/root-layout-position-options";
import DynamicComponentContextualMenu
  from "%/dynamic-component-editor/components/DynamicComponentContextualMenu.vue";
import AppearanceOptions from "%/dynamic-component-editor/bundles/appearance-options";
import PositioningOptions from "%/dynamic-component-editor/bundles/positioning-options";
import BackgroundColor from "%/dynamic-component-editor/options/background-color";
import BackgroundPosition from "%/dynamic-component-editor/options/background-position";
import BackgroundSize from "%/dynamic-component-editor/options/background-size";
import BackgroundRepeat from "%/dynamic-component-editor/options/background-repeat";
import BaseOption from "%/dynamic-component-editor/classes/base-option";
import EffectsOptions from "%/dynamic-component-editor/bundles/effects-options";
import AnimationEffectsOptions from "%/dynamic-component-editor/bundles/animation-effects-options";

export default {
  name: "VerticalContainer",
  components: { DynamicComponentContextualMenu },
  mixins: [LayoutElementMixin],
  deprecated: true,
  elementPanelSettings: {
    tags: ["container", "layout", "column", "stack", "vertical", "group"],
    displayName: "Vertical Container",
  },
  data() {
    return {
      VerticalLayoutAlign,
      VerticalLayoutVerticalAlign,
      LayoutWrap,
      BaseOption,
      BackgroundRepeat,
      BackgroundPosition,
      BackgroundColor,
      BackgroundSize,
    };
  },
  mounted() {
    if (this.editMode) {
      this.configureOptionsAndBuilder();
    }
  },
  optionBundles: [
    PositioningOptions,
    new VerticalLayoutPositionOptions({
      "default.layout-width": "hug",
      "default.layout-height": "fill",
    }),
    new AppearanceOptions({}, {
      "border-radius": false,
    }),
    AnimationEffectsOptions,
    new EffectsOptions({}, {
      "text-shadow": true,
    }),
    SpacingOptions,
    BackgroundOptions,
  ],
  methods: {
    configureOptionsAndBuilder() {
      if (this.isRootLayout) {
        this.setEditorElementConfig(this.configuration.identifier, "isDeletable", false);
        this.setEditorElementConfig(this.configuration.identifier, "isDraggable", false);
        this.setEditorElementConfig(this.configuration.identifier, "isDuplicatable", false);
        this.setEditorElementConfig(this.configuration.identifier, "canWrap", false);
        this.setEditorElementConfig(this.configuration.identifier, "canCreateCustomComponent", false);

        if (this.isPage) {
          this.setEditorElementOptionsConfig(this.configuration.identifier, {
            bundles: [
              new PositioningOptions({
                "default.positioning": {
                  position: "relative",
                  top: "unset",
                  right: "unset",
                  bottom: "unset",
                  left: "unset",
                },
              }),
              RootLayoutPositionOptions,
              new AppearanceOptions({}, {
                "visible": {
                  disable: true,
                  message: "Visibility can not be toggled for root containers",
                },
                "border-radius": false,
              }),
              SpacingOptions,
              BackgroundOptions,
            ],
          });
        }
      }
    },
  },
};
</script>
